import React, { useCallback } from "react";
import { ModalBody, ModalHeader } from "reactstrap";
import NiceModal from "@ebay/nice-modal-react";
import { ModalWrapper } from "components/ModalWrapper";
import Product3DModel from "components/_ProductConfigurator/SubComponents/Product3DModel";
import {
  useProductsOverviewStore,
  useProductsOverviewActions,
} from "stores/productsOverviewStore";
import { useTranslate } from "hooks";

export const Product3dViewModal = NiceModal.create(({ requestParams }) => {
  const translate = useTranslate();
  const waitingFor3dModel = useProductsOverviewStore(
    (state) => state.waitingFor3dModel,
  );
  const { setWaitingFor3dModel } = useProductsOverviewActions();
  const modal = NiceModal.useModal();

  const handleToggleModal = useCallback(() => {
    setWaitingFor3dModel(true);
    modal.resolve();
    modal.remove();
  }, [modal, setWaitingFor3dModel]);

  return (
    <ModalWrapper
      isOpen={modal.visible}
      centered={true}
      size="xl"
      toggle={handleToggleModal}
      isLoading={waitingFor3dModel && waitingFor3dModel !== "failed"}
    >
      <ModalHeader
        toggle={handleToggleModal}
        tag="div"
        className="d-flex align-items-start"
      >
        <h3>{translate("PRODUCT_CONFIGURATOR_3D")}</h3>
      </ModalHeader>
      <ModalBody>
        {waitingFor3dModel === "failed" ? (
          <h5>{translate("PRODUCT_CONFIGURATOR_3D_NOT_AVAILABLE")}</h5>
        ) : (
          <Product3DModel requestParams={requestParams} />
        )}
      </ModalBody>
    </ModalWrapper>
  );
});
